module.exports = __webpack_public_path__ + "img/Löschtrupp.2f491969.svg";